module.exports = __webpack_public_path__ + "close.777b93c6d5a7b86081144f8d0d3ca1d8.svg";